import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { FirebaseConfig } from "./model/FireBaseModel";
import { Utils } from "./common/Utils";

const firebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyBvxqkxzikFrRNgLhZrnM_N6Bj4G2Tux6Y",
  authDomain: "ecommerce-1bcb6.firebaseapp.com",
  projectId: "ecommerce-1bcb6",
  storageBucket: "ecommerce-1bcb6.firebasestorage.app",
  messagingSenderId: "69746076479",
  appId: "1:69746076479:web:19edcea2ef861b921f818a",
  measurementId: "G-X07FWZZ4RW"
}

export const getSiteKey = (): string => {
  const domainName = Utils.GetDomain();
  return domainName === "orderq" || domainName === "localhost" ? Utils.GetAlias() : domainName;
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app, getSiteKey());
const maindb = getFirestore(app);
const storage = getStorage(app);

export { auth, db, maindb, storage};
